import { Card } from '@zenid/web';
import { Link } from 'react-router';
import { css, cx } from '../../../../../styled-system/css';
import { flex } from '../../../../../styled-system/patterns';
import { button } from '../../../../../styled-system/recipes';
import type { ChangeFormProps } from '../ChangeForm/ChangeForm';
import { ChangeForm } from '#/features/emailChange/components/ChangeForm';

export type EmailChangeProps = ChangeFormProps;

export function EmailChange({ onSubmit, register, formState }: EmailChangeProps) {
  return (
    <Card className={css({ backgroundColor: '{colors.background.white}' })}>
      <div
        className={flex({
          padding: '{spacing.20} {spacing.20} {spacing.40} {spacing.20}',
          flexDirection: 'column',
          justifyContent: 'center',
          sm: {
            padding: '{spacing.40}',
          },
        })}
      >
        <h1
          className={css({
            textStyle: 'headding.l',
            paddingTop: '{spacing.24}',
            paddingBottom: '{spacing.16}',
            textAlign: 'center',
            color: '{colors.text.main}',
          })}
        >
          メールアドレスの変更
        </h1>
        <p className={css({ textStyle: 'body.m.default', color: '{colors.text.sub}', textAlign: 'center' })}>
          新しいメールアドレスを入力してください。
        </p>
      </div>
      <ChangeForm onSubmit={onSubmit} register={register} formState={formState} />
      <div
        className={flex({
          padding: '0 {spacing.20} {spacing.40}',
          marginTop: '-16px', // ChangeForm の paddingBottom を打ち消して「設定する」との間隔を揃える
          flexDirection: 'column',
          sm: {
            padding: '0 {spacing.40} {spacing.40}',
          },
        })}
      >
        <Link
          to="/home"
          data-testid="back-to-mypage-link"
          className={cx(
            button({ color: 'secondary', size: 'l', stretch: 'container' }),
            flex({ alignItems: 'center', justifyContent: 'center', textAlign: 'center' })
          )}
        >
          マイページに戻る
        </Link>
      </div>
    </Card>
  );
}
